
const metaChanger = function(metaTags) {
    metaTags.forEach(element => {
        if(element.name && element.name != 'title') {
            if(document.querySelector(`meta[name='${element.name}']`)) {
                document.querySelector(`meta[name='${element.name}']`).setAttribute('content', element.content? unescapeHtml(element.content): element.content) 
            } else {
                const tag = document.createElement('meta')
                Object.keys(element).forEach(key => {
                    tag.setAttribute(key, element[key] ? unescapeHtml(element[key]) : element[key])
                })
                document.head.appendChild(tag)
            }
        }
        if(element.property) {
            if(document.querySelector(`meta[property='${element.property}']`)) {
                document.querySelector(`meta[property='${element.property}']`).setAttribute('content', element.content? unescapeHtml(element.content): element.content) 
            } else {
                const tag = document.createElement('meta')
                Object.keys(element).forEach(key => {
                    tag.setAttribute(key, element[key] ? unescapeHtml(element[key]) : element[key])
                })
                document.head.appendChild(tag)
            }
        }
    });
}


const unescapeHtml = function(text) {
    var specialchars = [
      ['–', '&ndash;'],
      ['—', '&mdash;'],
      ['·', '&middot;'],
      ['•', '&bull;'],
      ['⋆', '&#8902;'],
      ['«', '&laquo;'],
      ['»', '&raquo;'],
      ['<', '&lt;'],
      ['>', '&gt;'],
    ]
    
    if(!text) {
        return text
    }
    
    var unescapedString = text
  
    // For each of the special characters,
    var len = specialchars.length
    for (var x = 0;x < len;x++) {
      // Replace all instances of the special character with its entity.
      unescapedString = unescapedString.replace(
        new RegExp(specialchars[x][1], 'g'),
        specialchars[x][0]
      )
    }
  
    return unescapedString
}

export { metaChanger }


// WEBPACK FOOTER //
// ./src/misc/meta-changer.js